import styled from 'styled-components';
import { Typography } from '../../global/theme';

export const CardWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  border-radius: 12px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  margin: 20px 24px 0;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CardTitle = styled.h2`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1px 0px;
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: 0;
`;

export const CardDesc = styled.p`
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0;
`;

export const CardDescription = styled.div`
  display: flex;
  padding-left: 34px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: none;
  background: transparent;
  ${Typography.body_md}
  color: var(--text-primary);
  input {
    ${Typography.body_md}
    color: var(--text-primary);
    width: 100%;
    border: none;
    background: transparent;
    padding: 0;
    min-height: 40px;
    :focus-visible {
      outline: none;
    }
  }
`;

export const CardBottomSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  justify-content: space-between;
`;

export const TabDisplay = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  flex: 1 0 0;
  flex-wrap: wrap;
`;

export const TabSection = styled.div`
  display: flex;
  align-items: center;
  border-radius: 6px;
  border: 0.5px solid var(--border-primary);
  overflow: hidden;
  .icon-up {
    position: relative;
    left: -6px; /* or whatever offset looks best */
  }
  .status-icon-container {
    display: flex;
    align-items: center;
    position: relative;
  }
`;
export const Chip = styled.div`
  display: flex;
  padding: 3px 8px;
  align-items: center;
  gap: 6px;
  border-radius: 0px;
  border-right: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  cursor: pointer;
  span {
    ${Typography.body_md_medium}
    color: var(--text-primary);
  }
  &:nth-child(4) {
    border-right: none;
  }
`;

export const DropButton = styled.div`
  display: flex;
  padding: 3px 8px;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  svg {
    padding: 2px 0;
  }
  p {
    margin: 0;
  }
  span {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
  }
`;
export const DisplayBtn = styled.div`
  display: flex;
  padding: 3px 8px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  color: var(--text-primary);
`;

export const CardFilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--background-tertiary);
  border-radius: 8px;
  padding: 8px 16px;
  margin-bottom: 16px;
`;

export const CardDisplayBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  padding: 4px 12px;
  cursor: pointer;
  font-size: 1rem;
  color: var(--text-primary);
  margin-left: auto;
  transition: background 0.2s;
  &:hover {
    background: var(--background-muted);
  }
`;

export const TitleBar = styled.div`
  display: flex;
  gap: 8px;
  input {
    width: 100%;
    border: none;
    background: transparent;
    padding: 0;
    ${Typography.heading_lg}
    color: var(--text-primary);
    :focus-visible {
      outline: none;
    }
    ::placeholder {
      color: var(--text-placeholder);
    }
  }
`;

export const IconDiv = styled.div`
  display: flex;
  align-items: center;
  .task-human-icon {
    fill: var(--text-primary);
  }
`;

export const DropDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 12px 0px 12px;
  gap: 12px;
  min-height: 281px;
`;

export const TabButtonDiv = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  align-self: stretch;
`;
export const TabItem = styled.div<{ isActive?: boolean }>`
  display: flex;
  padding: 3px 8px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: ${(props) => (props.isActive ? 'var(--background-muted)' : 'transparent')};
  color: ${(props) => (props.isActive ? 'var(--text-primary)' : 'var(--text-secondary)')};
  ${Typography.body_md_medium}
  cursor: pointer;

  &:hover {
    background: var(--background-muted);
    color: var(--text-primary);
  }
`;

export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const ColorsDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Circles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const LineDiv = styled.div`
  width: 0.5px;
  height: 24px;
  background: var(--border-primary);
`;

export const IconButton = styled.div`
  display: flex;
  padding: 3px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  cursor: pointer;
`;

export const ColorDots = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--text-tertiary);
    margin: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      margin: 0;
      width: 24px;
      height: 24px;
    }
  }
`;

export const IconsDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  .EmojiPickerReact {
    background-color: var(--background-primary);
  }
  .epr_-99lr9q {
    background-color: var(--background-primary);
  }
  .epr_-6npj90 {
    border-style: none;
    width: 100% !important;
  }
  .epr_-kg0voo {
    display: none;
  }
  .epr-body {
    width: 100%;
  }
  .EmojiPickerReact li.epr-emoji-category > .epr-emoji-category-content {
    margin: 0px;
  }
  .EmojiPickerReact .epr-skin-tones {
    display: none;
  }
  .EmojiPickerReact .epr-category-nav {
    display: none;
  }
  .epr_-8ygbw8 {
    padding: 0 !important;
  }
  .epr-search-container .epr_-2zpaw9 {
    display: flex;
    height: 26px;
    padding: 3px 10px;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    border: 0.5px solid var(--border-primary);
    background: var(--background-tertiary);
    ${Typography.body_md}
    color: var(--text-primary);
    :placeholder {
      color: var(--text-secondary);
    }
    :focus-visible {
      outline: none;
    }
  }
  .epr-search-container {
    display: flex;
    padding: 3px 0px;
    align-items: center;
    gap: 59px;
  }

  .EmojiPickerReact:not(.epr-search-active) .epr-category-nav > button.epr-cat-btn.epr-active,
  .EmojiPickerReact li.epr-emoji-category > .epr-emoji-category-label {
    padding-top: 8px !important;
  }
  .epr_gd8l4g {
    padding: 0;
  }
  .EmojiPickerReact button.epr-emoji {
    max-height: 28px !important;
    max-width: 28px !important;
    height: 28px !important;
    width: 28px !important;
    border-radius: 6px;
    :hover {
      background-color: var(--neutral-secondary);
    }
  }
  .EmojiPickerReact button.epr-emoji .epr-emoji-img {
    padding: 6px !important;
    max-height: 28px !important;
    max-width: 28px !important;
    min-height: 28px !important;
    min-width: 28px !important;
  }
  .EmojiPickerReact li.epr-emoji-category > .epr-emoji-category-content {
    gap: 0 !important;
  }
`;

export const SearchDiv = styled.div`
  display: flex;
  padding: 2px 0px;
  align-items: center;
  gap: 59px;
`;

export const Input = styled.input`
  display: flex;
  padding: 3px 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-tertiary);
  ${Typography.body_md}
  color: var(--text-primary);
  :placeholder {
    color: var(--text-secondary);
  }
  :focus-visible {
    outline: none;
  }
`;

export const IconsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  overflow: auto;
  max-height: 172px;
  ::-webkit-scrollbar {
    display: block !important;
    width: 4px;
    height: 30px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--text-tertiary);
    border-radius: 2px;
  }
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  height: 28px;

  span {
    width: 16px;
    height: 16px;
    font-size: 16px;
    line-height: 16px;
    // margin-left: -4px;
  }
  &:hover {
    background: var(--neutral-secondary) !important;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  margin-left: -6px;
`;

export const AddIconDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const DropIconButton = styled.div`
  display: flex;
  padding: 5px;
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  cursor: pointer;
  :hover {
    background: var(--background-secondary);
  }
`;
export const IconBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  cursor: pointer;
  :hover {
    background: var(--background-secondary);
  }
  .task-human-icon {
    fill: var(--text-primary);
  }
`;

export const UploadImageDiv = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  min-height: 240px;
`;

export const ImageContainer = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 0.5px solid var(--border-primary);
  overflow: hidden;
`;

export const UploadTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  p {
    margin: 0;
    ${Typography.body_md};
    color: var(--text-secondary);
    text-align: center;
  }
`;

export const UploadButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  ${Typography.body_sm};
  color: var(--text-primary);
`;

export const SVGIconDiv = styled.div`
  width: max-content;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  border-radius: 6px;
  cursor: pointer;
`;

export const EmptyText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 58px 0 74px 0;
`;
